/* eslint-disable react/prop-types */
import React from 'react';
import ScriptTag from 'react-script-tag';

// TODO SHOULD BE CONVERTED TO TSX FILE AS SOON AS TABLEAU JS API V3 CAN BE INSTALLED AS A PACKAGE
export default function TableauOnlineDashboard(props) {
    return (
        <>
            <ScriptTag type="module"
                       src="https://embedding.tableauusercontent.com/tableau.embedding.3.11.0.min.js"></ScriptTag>
            <tableau-viz
                id="tableauViz"
                src={props.source}
                token={props.token}
                toolbar="show"
                iframe-attr-style={`height: ${window.innerHeight - 49}px`}
            >
            </tableau-viz>
        </>
    );
}
